// Barrios cubiertos por Limpack, agrupados por día de ruta.
// Fuente: maquetas/tienda-v5-barrios.html. Consumido por la página Barrios (tienda v5).
// Colores de zona: teal = Lun/Jue · gold = Martes · green = Mié/Vie.
// El mapa Leaflet de la maqueta quedó desactivado por decisión de producto (2026-07),
// así que estos datos alimentan solo los grupos de chips (no hay polígonos geo acá).

export const GRUPOS_BARRIOS = [
  {
    id: 'lun-jue',
    color: 'teal',
    emoji: '🟢',
    dia: 'Lunes y Jueves',
    resumen: 'Pocitos + Punta Carretas + Villa Biarritz',
    barrios: [
      { nombre: 'Pocitos', nota: 'Lun · Jue' },
      { nombre: 'Punta Carretas', nota: 'Lun · Jue' },
      { nombre: 'Villa Biarritz', nota: 'Lun · Jue' },
    ],
  },
  {
    id: 'martes',
    color: 'gold',
    emoji: '🟡',
    dia: 'Martes',
    resumen: 'Centro-sur: Cordón, Palermo, Parque Batlle, Parque Rodó',
    barrios: [
      { nombre: 'Cordón', nota: 'Martes' },
      { nombre: 'Palermo', nota: 'Martes · Entre Cordón y Parque Rodó' },
      { nombre: 'Parque Batlle', nota: 'Martes' },
      { nombre: 'Parque Rodó', nota: 'Martes' },
    ],
  },
  {
    id: 'mie-vie',
    color: 'green',
    emoji: '🔵',
    dia: 'Miércoles y Viernes',
    resumen: 'Costa este: Buceo, Malvín, Punta Gorda, Carrasco',
    barrios: [
      { nombre: 'Buceo', nota: 'Mié · Vie' },
      { nombre: 'Malvín', nota: 'Mié · Vie' },
      { nombre: 'Punta Gorda', nota: 'Mié · Vie' },
      { nombre: 'Carrasco', nota: 'Mié · Vie' },
      { nombre: 'Carrasco Norte', nota: 'Mié · Vie' },
    ],
  },
];

// Total de barrios activos (para el KPI del hero) — derivado de los grupos.
export const TOTAL_BARRIOS = GRUPOS_BARRIOS.reduce((n, g) => n + g.barrios.length, 0);

// KPIs del hero. dias/envío hardcoded (no derivables de los grupos).
export const BARRIOS_KPIS = [
  { num: String(TOTAL_BARRIOS), label: 'barrios activos' },
  { num: '5', label: 'días de reparto' },
  { num: '$0', label: 'costo de envío' },
];
